var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainPetFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_2914)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 18.3796,
    width: 31,
    height: 2.6,
    rx: 1.3,
    fill: "#FFD15B",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.3172V18.3172H30.5V14.3172C30.5 14.3172 29.6687 10.8875 28.3587 10.3172C27.0488 9.74688 5.8 9.91718 5 10.3172C4.2 10.7172 3.33333 13.1505 3 14.3172Z",
    fill: "#FEF1AD",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82443 7.08517C6.53694 7.6271 6.063 9.36717 6.22599 10.172C13.9725 9.95803 18.3251 9.99741 27.0397 10.172C27.923 9.22097 26.4425 7.08517 24.9088 7.08517C26.1008 5.12915 23.7152 3.09345 22.0665 3.90664C21.9442 1.36994 19.6774 1.03929 18.3684 2.53131C17.3752 0.118393 15.073 0.897571 14.3036 2.53131C12.3476 1.18656 10.2205 2.53131 10.6666 4.27339C8.49667 3.47877 7.28071 5.82073 7.82443 7.08517Z",
    fill: "#C07946",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0332,
    cy: 5.80896,
    r: 0.562256,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.1877,
    cy: 6.93347,
    r: 0.562256,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.4146,
    cy: 4.46149,
    r: 0.562256,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5063,
    cy: 6.93347,
    r: 0.562256,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6516 12.8593L15.1017 12.6416C15.1269 12.6937 15.1616 12.736 15.194 12.7611C15.2232 12.7838 15.2407 12.7859 15.25 12.7859H18.25C18.2593 12.7859 18.2768 12.7838 18.306 12.7611C18.3384 12.736 18.373 12.6938 18.3982 12.6418C18.6801 12.0574 19.3134 11.6921 20 11.6921C20.902 11.6921 21.75 12.3448 21.75 13.2859C21.75 13.7218 21.5614 14.1017 21.2732 14.3796C21.5614 14.6575 21.75 15.0375 21.75 15.4734C21.75 16.4145 20.902 17.0671 20 17.0671C19.3133 17.0671 18.6797 16.7017 18.398 16.117L18.8484 15.9L18.3983 16.1177C18.3731 16.0656 18.3384 16.0233 18.306 15.9982C18.2768 15.9755 18.2593 15.9734 18.25 15.9734H15.25C15.2407 15.9734 15.2232 15.9755 15.194 15.9982C15.1616 16.0233 15.127 16.0655 15.1018 16.1175C14.8199 16.7019 14.1865 17.0671 13.5 17.0671C12.598 17.0671 11.75 16.4145 11.75 15.4734C11.75 15.0375 11.9386 14.6575 12.2268 14.3796C11.9386 14.1017 11.75 13.7218 11.75 13.2859C11.75 12.3448 12.598 11.6921 13.5 11.6921C14.1867 11.6921 14.8203 12.0575 15.102 12.6423L14.6516 12.8593ZM14.6516 12.8593C14.4625 12.4669 14.0172 12.1921 13.5 12.1921C12.8094 12.1921 12.25 12.6816 12.25 13.2859C12.25 13.5998 12.4015 13.8833 12.644 14.0827L18.8484 12.8593C18.7406 13.0822 18.5266 13.2859 18.25 13.2859H15.25C14.9734 13.2859 14.7594 13.0822 14.6516 12.8593Z",
    fill: "#FE4755",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_2914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 22,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainPetFood);
export default __webpack_public_path__ + "static/media/icon-main-pet-food.50aaab1f80cc4ce585b3cdcac420b336.svg";
export { ForwardRef as ReactComponent };